import { LoadState } from "../../../constants/enums";

export interface IGLFiscalYearClose {
  gl_fiscal_year_close_code: string | null;
  fiscal_years_code: string | null;
  closing_fiscal_year_month_code: string | null;
  opening_fiscal_year_month_code: string | null;
  total_income: number | null;
  total_expense: number | null;
  net_income: number | null;
  retained_earnings_gl_code: string | null;
  re_opening_before: number | null;
  re_opening_after: number | null;
  rollforward_mode: string | null;
  net_income_by_branch: Record<string, number> | null;
  status: string | null;
  created_by_name: string | null;
  create_ts: string | null;
}

export interface IGLFiscalYearCloseState {
  list: IGLFiscalYearClose[];
  loading: LoadState;
  totalRecords: number;
  error: string | null;
}

export const initialGLFiscalYearCloseState: IGLFiscalYearCloseState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  error: null,
};
